import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { isLoggedIn } from "@/lib/auth";
import { dashboardPath } from "./routes/route";
import { routes } from "./routes/paths";

function App() {
	const navigate = useNavigate();

	useEffect(() => {
		if (!isLoggedIn()) {
			navigate(routes.LOGIN_PATH);
		} else {
			navigate(dashboardPath);
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return <></>
}

export default App;